import React from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import ThemeToggle from "./ThemeToggle";
import Brand from "./Brand";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/app/practice", label: "Writing Practice" },
  { to: "/app/sat-ap", label: "SAT/AP Prep" },
  { to: "/app/grammar", label: "Grammar Lab" },
  { to: "/app/essay", label: "Essay Coach" },
  { to: "/app", label: "Progress Tracker" },
  { to: "/#pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function PublicHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header data-testid="public-header" className="bg-white/85 backdrop-blur-xl border-b border-slate-200/60 sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between gap-4">
        <Brand to="/" tone="light" size="md" testId="brand-link" />
        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase().replace(/[\/\s]+/g,'-')}`}
              className="px-3 py-2 rounded-full text-sm font-semibold text-slate-700 hover:bg-slate-100">
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <ThemeToggle />
          <Link to="/login" data-testid="header-login" className="hidden sm:inline text-sm font-bold text-slate-700 px-4 py-2">Login</Link>
          <Link to="/register" data-testid="header-register" className="hidden sm:inline text-sm font-bold text-white bg-indigo-600 hover:bg-indigo-500 rounded-full px-5 py-2.5 tactile-shadow">
            Get Started
          </Link>
          <button data-testid="mobile-menu-toggle" onClick={()=>setOpen(!open)}
            className="lg:hidden w-10 h-10 rounded-2xl border-2 border-slate-200 grid place-items-center">
            {open ? <X size={18}/> : <Menu size={18}/>}
          </button>
        </div>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-slate-100 bg-white">
          <div className="px-6 py-3 flex flex-col gap-1">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} onClick={()=>setOpen(false)}
                className="px-3 py-2.5 rounded-2xl text-sm font-semibold text-slate-700 hover:bg-slate-100">
                {n.label}
              </Link>
            ))}
            <div className="border-t border-slate-100 my-2" />
            <Link to="/login" onClick={()=>setOpen(false)} className="px-3 py-2.5 rounded-2xl text-sm font-bold text-slate-700">Login</Link>
            <Link to="/register" onClick={()=>setOpen(false)} className="px-3 py-2.5 rounded-2xl text-sm font-bold bg-indigo-600 text-white text-center">Get Started</Link>
          </div>
        </div>
      )}
    </header>
  );
}
